module.exports = __webpack_public_path__ + "img/0Q3C6212_Black.7e20eb9b.jpg";